import type { Channel as StreamChannel } from 'stream-chat';

export const extractMessages = (channel: StreamChannel) => {
  const { state: stateNew } = channel;
  return stateNew.messageSets[0]?.messages || [];
};
